/* ============================================================
   ANJUS — Product detail interactions (Shopify)
   Operates on markup rendered by sections/main-product.liquid.
   ============================================================ */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-root]');
  if (!root) return;

  function chev(dir) {
    var s = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">';
    if (dir === 'left') return s + '<path d="M15 6l-6 6 6 6"/></svg>';
    if (dir === 'right') return s + '<path d="M9 6l6 6-6 6"/></svg>';
    if (dir === 'close') return s + '<path d="M6 6l12 12M18 6L6 18"/></svg>';
    return s + '</svg>';
  }

  /* ---------- lightbox ---------- */
  var gallery = root.querySelector('.bvl-gallery');
  if (gallery) {
    var shots = Array.prototype.slice.call(gallery.querySelectorAll('.bvl-shot img'));
    var srcs = shots.map(function (img) { return img.getAttribute('data-full') || img.src; });
    if (srcs.length) {
      var lb = document.createElement('div');
      lb.className = 'bvl-lightbox';
      var rail = srcs.length > 1
        ? '<div class="bvl-lb-rail">' + srcs.map(function (src, i) { return '<button class="bvl-lb-thumb" data-i="' + i + '" aria-label="View image ' + (i + 1) + '"><img src="' + src + '" alt=""></button>'; }).join('') + '</div>'
        : '';
      lb.innerHTML =
        '<button class="bvl-lb-close" aria-label="Close">' + chev('close') + '</button>' + rail +
        (srcs.length > 1 ? '<button class="bvl-lb-nav bvl-lb-prev" aria-label="Previous">' + chev('left') + '</button>' : '') +
        '<div class="bvl-lb-stage"><img alt=""></div>' +
        (srcs.length > 1 ? '<button class="bvl-lb-nav bvl-lb-next" aria-label="Next">' + chev('right') + '</button>' : '');
      document.body.appendChild(lb);
      var lbImg = lb.querySelector('.bvl-lb-stage img');
      var current = 0;
      function show(i) { current = (i + srcs.length) % srcs.length; lbImg.src = srcs[current]; lb.querySelectorAll('.bvl-lb-thumb').forEach(function (t) { t.classList.toggle('is-active', +t.getAttribute('data-i') === current); }); }
      function openLb(i) { show(i); lb.classList.add('open'); document.body.style.overflow = 'hidden'; }
      function closeLb() { lb.classList.remove('open'); document.body.style.overflow = ''; }
      gallery.querySelectorAll('.bvl-shot').forEach(function (fig, i) { fig.addEventListener('click', function () { openLb(i); }); });
      lb.querySelectorAll('.bvl-lb-thumb').forEach(function (t) { t.addEventListener('click', function (e) { e.stopPropagation(); show(+t.getAttribute('data-i')); }); });
      lb.addEventListener('click', function (e) {
        if (e.target.closest('.bvl-lb-close')) { closeLb(); return; }
        if (e.target.closest('.bvl-lb-prev')) { e.stopPropagation(); show(current - 1); return; }
        if (e.target.closest('.bvl-lb-next')) { e.stopPropagation(); show(current + 1); return; }
        if (e.target.closest('.bvl-lb-stage')) closeLb();
      });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('open')) return;
        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft' && srcs.length > 1) show(current - 1);
        if (e.key === 'ArrowRight' && srcs.length > 1) show(current + 1);
      });
    }
  }

  /* ---------- accordions ---------- */
  root.querySelectorAll('.bvl-acc-head').forEach(function (h) { h.addEventListener('click', function () { h.parentElement.classList.toggle('open'); }); });

  /* ---------- related-section tabs (Continue the Collection / You may also like) ---------- */
  var relTabs = root.querySelector('[data-rel-tabs]');
  if (relTabs) {
    var rtabs = relTabs.querySelectorAll('.bvl-tab');
    var rpanels = relTabs.querySelectorAll('.bvl-tab-panel');
    rtabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.getAttribute('data-tab');
        rtabs.forEach(function (t) { var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        rpanels.forEach(function (p) { p.hidden = p.getAttribute('data-panel') !== key; });
      });
    });
  }

  /* ---------- ring size -> line-item property ---------- */
  var ringSel = root.querySelector('#ringSizeSel');
  var ringProp = root.querySelector('[data-ring-size-prop]');
  if (ringSel && ringProp) {
    ringSel.addEventListener('change', function () { ringProp.value = ringSel.value; ringProp.disabled = !ringSel.value; });
  }

  /* ---------- gift note: never attach an empty property ---------- */
  var giftNote = root.querySelector('[data-gift-note]');
  var giftForm = root.querySelector('form[data-ajax-cart]');
  if (giftNote && giftForm) {
    giftForm.addEventListener('submit', function () {
      giftNote.disabled = !giftNote.value.trim();          // disabled fields are excluded from FormData
      setTimeout(function () { giftNote.disabled = false; }, 0); // re-enable for the next add
    });
  }

  /* ---------- ring size guide modal ---------- */
  var sizeBtn = root.querySelector('#sizeGuideBtn');
  var sizeModal = document.querySelector('#size-modal');
  if (sizeBtn && sizeModal) {
    function openSize() { sizeModal.classList.add('open'); document.body.style.overflow = 'hidden'; }
    function closeSize() { sizeModal.classList.remove('open'); document.body.style.overflow = ''; }
    sizeBtn.addEventListener('click', openSize);
    sizeModal.addEventListener('click', function (e) { if (e.target.closest('[data-size-close]')) closeSize(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sizeModal.classList.contains('open')) closeSize(); });
  }

  /* ---------- sticky purchase bar ---------- */
  var bar = document.getElementById('stickyBar');
  if (bar) {
    var cta = root.querySelector('.bvl-cta');
    var footer = document.querySelector('.site-footer');
    function syncBar() {
      if (!cta) return;
      var r = cta.getBoundingClientRect();
      var ctaPassed = r.bottom < 0;                 // main Add-to-Cart scrolled above the top
      var footerVisible = false;
      if (footer) { footerVisible = footer.getBoundingClientRect().top < (window.innerHeight * 0.92); }
      bar.classList.toggle('show', ctaPassed && !footerVisible);
    }
    window.addEventListener('scroll', syncBar, { passive: true });
    window.addEventListener('resize', syncBar, { passive: true });
    syncBar();
    var sbBtn = bar.querySelector('#sbBtn');
    var form = root.querySelector('form[data-ajax-cart]');
    if (sbBtn && form) sbBtn.addEventListener('click', function (e) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.querySelector('[type=submit]').click(); });
  }
})();